// Vendor
import vhCheck from "vh-check";
vhCheck();

import "./modules/lazyloading";

// Sections
import "./sections/header";
import "./sections/marquee";
import "./sections/product";
import "./sections/main-article";
import "./sections/main-blog";
import "./sections/section-ingredients";
import "./sections/section-faqs";
import "./sections/collections-shopthelook";
import "./sections/section-video-lightbox";
import "./sections/before-after";
import "./sections/verified-reviews";
import "./sections/expert-endorsements";
import "./sections/judgeme-reviews";
import "./sections/sliding-content";
import "./sections/flex-media";
import "./sections/main-collection-grid";
import "./sections/tabbed-content";
import "./sections/quiz.ts";

// Snippets
import "./snippets/badges";
import "./snippets/card-blog";
import "./snippets/klaviyo-popup";
import "./snippets/shipping-popup-heading";

// Cart
import "./sections/cart";

// Import utils to Window
import { utils } from "./modules/utils";
window.utils = utils;

// Alpine
import "./alpine/main";

// import {
//   setLocalization,
//   initLocalizationForm,
// } from "./snippets/set-localization";
// setLocalization();
// initLocalizationForm();
